import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, Icon, TextArea, Header, Segment, Dropdown, Label, Modal, Checkbox } from 'semantic-ui-react';
import i18next from 'i18next';

const cancelationReasons = [
    'posCompanyIssue', 'unfamiliarityWithPaidit', 'outOfStock', 'restaurantHasClosed',
    'deliveryDidNotArrive', 'canceledAtPOS', 'testing', 'other'
];

class CancelOrderModal extends Component {
    defaultCancelationFormData = {
        reason: '',
        details: '',
        notifyUser: true
    };

    state = { cancelationFormData: { ...this.defaultCancelationFormData } }

    handleModalClose = () => {
        this.props.onClose();
        this.setState({ cancelationFormData: { ...this.defaultCancelationFormData } });
    }

    handleCancelOrder = () => {
        this.props.onApprove(this.state.cancelationFormData);
        this.setState({ cancelationFormData: { ...this.defaultCancelationFormData } });
    }

    handleOrderCancelationMultipleChanges(obj) {
        this.setState({ cancelationFormData: { ...this.state.cancelationFormData, ...obj } });
    }

    handleOrderCancelationChange(prop, value) {
        this.setState({ cancelationFormData: { ...this.state.cancelationFormData, [prop]: value } });
    }

    renderOrderCancelationForm() {
        const reasonOptions = cancelationReasons.map(reason =>
            ({ key: reason, text: i18next.t(`orders.cancelForm.reasons.${reason}`), value: reason }));

        return (
            <Grid padded className='pi-cancel-order-form-grid'>
                <Grid.Row className='pi-cancel-order-form-grid-row pi-cancel-order-form-reason-row'>
                    <Button as='div' labelPosition='left'>
                        <Label>
                            <Icon name='question circle' />
                            {i18next.t('orders.cancelForm.cancelationReason')}
                        </Label>
                        <Dropdown button floating
                            options={reasonOptions}
                            value={this.state.cancelationFormData.reason}
                            onChange={(event, data) => {
                                this.handleOrderCancelationMultipleChanges({
                                    reason: data.value,
                                    notifyUser: data.value !== "testing" ? true : false
                                });
                            }} />
                    </Button>
                </Grid.Row>
                <Grid.Row className='pi-cancel-order-form-grid-row'>
                    <Header as='h5'>{i18next.t('inDetail')}: </Header>
                    <TextArea autoHeight
                        placeholder={i18next.t('general.optional')}
                        onChange={(event, data) => this.handleOrderCancelationChange('details', data.value)}
                        className='pi-cancel-order-form-details' />
                </Grid.Row>
                <Grid.Row className='pi-cancel-order-form-grid-row'>
                    <Checkbox
                        label={i18next.t('orders.cancelForm.notifyUser')}
                        checked={this.state.cancelationFormData.notifyUser}
                        onChange={(event, data) => this.handleOrderCancelationChange('notifyUser', data.checked)}
                    />
                </Grid.Row>
                {this.state.cancelationFormData.reason ?
                    <Grid.Row className='pi-cancel-order-form-grid-row'>
                        <Segment secondary>
                            <Icon name='warning sign' color='yellow' />
                            <b>{i18next.t('orders.cancelForm.cancelationWarning')}</b>
                        </Segment>
                    </Grid.Row> : null
                }
            </Grid>
        );
    }

    render() {
        const { isVisible } = this.props;

        return (
            <Modal
                dimmer={'blurring'}
                open={isVisible}
                onClose={this.handleModalClose}
                style={{ direction: i18next.dir() }}
                className='pi-cancel-order-form' >
                <Modal.Header>
                    <Icon name='times circle' />
                    {i18next.t('orders.cancelForm.title')}
                </Modal.Header>
                <Modal.Content>{this.renderOrderCancelationForm()}</Modal.Content>
                <Modal.Actions>
                    <Button
                        color='red' inverted
                        onClick={this.handleModalClose}
                    >
                        <Icon name='cancel' />{i18next.t('no')}
                    </Button>
                    <Button
                        color='green' inverted
                        disabled={!this.state.cancelationFormData.reason}
                        onClick={this.handleCancelOrder}
                    >
                        <Icon name='checkmark' />{i18next.t('yes')}
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

CancelOrderModal.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    onApprove: PropTypes.func
    
};

export default CancelOrderModal;